import * as web3 from "@solana/web3.js"
import { CSSProperties, useEffect, useState } from "react";
import { AuctionRoom } from "../models/AuctionRoom";
import { Auction } from "../models/Auction";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { useProgram } from "../utils/ProgramContext";
import { Provider } from "../models/Provider";
import { useParams } from "react-router-dom";
import { BN } from "@coral-xyz/anchor";

const styles: { [key: string]: CSSProperties } = {
	list: {
		padding: 0,
		listStyleType: 'none',
	},
	listItem: {
		margin: '10px 0',
		padding: '15px',
		borderRadius: '8px',
		boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
		border: '1px solid rgba(0, 0, 0, 0.1)',
		backgroundColor: '#fff',
	},
	name: {
		fontWeight: 'bold',
		marginBottom: '10px',
	},
	checkbox: {
		marginRight: '10px',
	},
};


function getTimestampInSeconds() {
	return Math.floor(Date.now() / 1000)
}

const ManageAuction = () => {

	const { id } = useParams();
	const { connection } = useConnection()
	const [provider, setProvider] = useState<Provider>();
	const [auctionRoom, setAuctionRoom] = useState<AuctionRoom>();
	const [auctions, setAuctions] = useState<Auction[]>([]);
	const [lastAuctionStart, setLastAuctionStart] = useState<number>(0)
	const [auctionToCreatePda, setAuctionToCreatePda] = useState<web3.PublicKey | null>(null);
	const { publicKey, sendTransaction } = useWallet()
	const { program } = useProgram() || {}


	useEffect(() => {
		async function fetchAuctionRoom() {
			if (!publicKey || !program || !id) {
				return
			}
			const [providerPda] = Provider.findAddress(publicKey, parseInt(id))
			const providerAccount = await program.account.provider.fetch(providerPda);
			setProvider(new Provider(providerAccount.id as number, providerAccount.name as string, providerAccount.location as string, providerPda))

			const [auctionRoomPda] = AuctionRoom.findAddress(providerPda);
			const auctionRoomAccount = await program.account.auctionRoom.fetch(auctionRoomPda);
			const auctionRoom = new AuctionRoom(new web3.PublicKey(auctionRoomPda), (auctionRoomAccount.timeDenomination as BN).toNumber())
			setAuctionRoom(auctionRoom)

			let startTime = Math.floor(getTimestampInSeconds() / auctionRoom.timeDenomination) * auctionRoom.timeDenomination;
			const auctionList: Auction[] = []
			let foundNextAvailableAuction = false;
			let auctionAccount = null;
			let tempAuctionToCreatePda = null;

			while (!foundNextAvailableAuction) {
				[tempAuctionToCreatePda] = Auction.findAddress(providerPda, startTime);
				try {
					auctionAccount = await program.account.auction.fetch(tempAuctionToCreatePda);
					auctionList.push(
						new Auction(
							tempAuctionToCreatePda,
							providerPda,
							auctionAccount.startTime as number,
							auctionAccount.startingPrice as number,
							auctionAccount.minBidDelta as number,
							auctionAccount.expiration as number,
							auctionAccount.currentPrice as number,
							auctionAccount.active as boolean,
							auctionAccount.reward as boolean,
							auctionAccount.highestBidder as web3.PublicKey
						)
					)
					startTime += auctionRoom.timeDenomination;
				}
				catch (e) {
					foundNextAvailableAuction = true
					setLastAuctionStart(startTime)
					break
				}
			}
			setAuctionToCreatePda(tempAuctionToCreatePda)
			setAuctions(auctionList as Auction[])

		}

		fetchAuctionRoom()

	}, [program, publicKey])


	async function handleCreateNewAuction() {

		if (!program || !publicKey || !provider || !auctionRoom || !auctionToCreatePda) {
			return
		}
		const startTime = lastAuctionStart;
		const transaction = await program.methods
			.createAuction(
				provider.id as number,
				new BN(startTime),
				new BN(startTime + auctionRoom.timeDenomination),
				new BN(1000),
				new BN(1000)
			).accounts({
				auction: auctionToCreatePda,
				auctionRoom: auctionRoom.publicKey,
				provider: provider.publicKey,
				authority: publicKey,
				systemProgram: web3.SystemProgram.programId
			}).transaction()

		try {
			const txid = await sendTransaction(transaction, connection);
			alert(
				`Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
			);
			console.log(
				`Transaction submitted: https://explorer.solana.com/tx/${txid}?cluster=devnet`
			);
		} catch (e) {
			console.log(JSON.stringify(e));
			alert(JSON.stringify(e));
		}

	}

	return (
		<main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
			<div className="flex items-center">
				<h1 className="text-lg font-semibold md:text-2xl">Auctions</h1>
			</div>
			<div className="flex flex-1 items-center justify-center rounded-lg border border-dashed shadow-sm">
				<div className="flex flex-col items-center gap-1 text-center">
					<ul style={styles.list}>
						{auctions.map((auction: Auction, index) => (
							<li key={index} style={styles.listItem}>
								<div style={styles.name}>PubKey: {auction.pubkey?.toString()}</div>
								<div style={styles.name}>Start: {new Date(auction.startTime * 1000).toLocaleTimeString('en-US')}</div>
								<div style={styles.name}>Expiration: {new Date(auction.expiration * 1000).toLocaleTimeString('en-US')}</div>
								<div style={styles.name}>Starting Price: {auction.startPrice / 10 ** 9} SOL</div>
								<div style={styles.name}>Minimum Delta: {auction.minBidDelta / 10 ** 9} SOL</div>
							</li>
						))}
					</ul>
					{auctionToCreatePda &&
						<button className={"m-5 bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"} onClick={handleCreateNewAuction}>Cretea Auction PDA</button>
					}
				</div>
			</div>
		</main>
	)
}




export default ManageAuction;